import React, {useEffect} from 'react'
import Navbar from '../component/Navbar';
import Hero from '../component/Hero';
import Fotter from '../component/Fotter';
import photo5 from '../assets/photo5.jpg';
import hello from '../assets/hello.jpg';

const Contact = () => {
  useEffect(() => {
    document.title = 'AN-TECH - CONTACT'; // Change the title as desired
    // Make sure to replace 'Your Website Name' with your actual website name
  }, []);
  return (
    <>
      <Navbar />
      <Hero
        backgroundImage={photo5}
        headingText="AN-TECH - CONTACT"
        paraText="Feel free to contact us; we will reply within 24 hours."
      />
       
  
    <section className="text-gray-400 bg-gray-900 body-font relative">
    
      <div className="container px-5 py-24 mx-auto flex sm:flex-nowrap flex-wrap">
    
        <div className="lg:w-2/3 md:w-1/2 bg-gray-900 rounded-lg overflow-hidden sm:mr-10 p-10 flex items-end justify-start relative">
          
          {/* Replace the iframe with an image */}
          <img
            src={hello}
            alt="Location"
            className="absolute inset-0 w-full h-full object-cover"
          
          />
          
          
          <div className="bg-gray-900 relative flex flex-wrap py-6 rounded shadow-md">
            <div className="lg:w-1/2 px-6">
              <h2 className="text-red title-font font-semibold tracking-widest text-xs">NOTE:</h2>
              <p className="mt-1 text-white">if we don't reply under 24 hour then please DM us on instagram or discord.</p>
            </div>
            <div className="lg:w-1/2 px-6 mt-4 lg:mt-0">
              <h2 className="title-font font-semibold text-white tracking-widest text-xs">EMAIL</h2>
              <a className="text-indigo-400 leading-relaxed">antech439@gmail.com</a>
     
            </div>
          </div>
        </div>
        <div className="lg:w-1/3 md:w-1/2 flex flex-col md:ml-auto w-full md:py-8 mt-8 md:mt-0">
          <h2 className="text-white text-lg mb-1 font-medium title-font">CONTACT US.</h2>
          <p className="leading-relaxed mb-5">Fell free to contact us..</p>
        <form action='https://formspree.io/f/mpzgyodw' method='POST'>
          <div className="relative mb-4">
            <label htmlFor="name" className="leading-7 text-sm text-white font-bold">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              className="w-full bg-gray-800 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 text-base outline-none text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>
          <div className="relative mb-4">
            <label htmlFor="email" className="leading-7 text-sm text-white font-bold">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              className="w-full bg-gray-800 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 text-base outline-none text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            />
          </div>
          <div className="relative mb-4">
            <label htmlFor="message" className="leading-7 text-sm text-white font-bold">Message</label>
            <textarea
              id="message"
              name="message"
              className="w-full bg-gray-800 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 h-32 text-base outline-none text-gray-100 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
            ></textarea>
          </div>
          <button type='submit' className="text-white font-bold bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg">Button</button>
          <p className="text-sm text-gray-400 text-opacity-90 mt-3"> Tell us about your exprience in our website if you are facing issues in our website then please text us.</p>
          </form>
        </div>
        
      </div>
      
    </section>
 {/* <div class="container mx-auto">
  <form action='https://formspree.io/f/mpzgyodw' method='POST' class="max-w-md mx-auto p-6">
    <div class="mb-4">
      <label for="name" class="block text-gray-700 text-sm font-bold mb-2">Name</label>
      <input type="text" id="name" name="name" class="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:border-blue-500" placeholder="John Doe"/>
    </div>

    <div class="mb-4">
      <label for="email" class="block text-gray-700 text-sm font-bold mb-2">Email</label>
      <input type="email" id="email" name="email" class="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:border-blue-500" placeholder="john@example.com"/>
    </div>

    <div class="mb-4">
      <label for="message" class="block text-gray-700 text-sm font-bold mb-2">Message</label>
      <textarea id="message" name="message" class="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:border-blue-500" rows="4" placeholder="Your message here"></textarea>
    </div>

    <div class="flex items-center justify-between">
      <button type="submit" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline-blue active:bg-blue-800">Submit</button>
    </div>
  </form>
</div>  */}

      <Fotter />
    </>
  )
}

export default Contact;
